import Pong from './Pong';

const ProfilePage = () => {
  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      color: 'white',
      backgroundColor: '#1a1a1a',
      minHeight: '100vh'
    }}>
      <header style={{
        textAlign: 'center',
        marginBottom: '40px'
      }}>
        <h1 style={{ fontSize: '2.5em', marginBottom: '20px' }}>
          Welcome to Matthew's Portfolio
        </h1>
        <p style={{ fontSize: '1.2em', lineHeight: '1.6', maxWidth: '800px', margin: '0 auto' }}>
          Hi! I'm Matthew, a passionate developer who loves creating interactive experiences 
          and solving complex problems. This site showcases some of my custom projects 
          and experiments in web development.
        </p>
      </header>

      <section style={{
        marginBottom: '40px',
        textAlign: 'center'
      }}>
        <h2 style={{ fontSize: '2em', marginBottom: '20px' }}>
          Featured Project: Interactive Pong
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Try out this classic game reimagined with modern web technologies. 
          Use 'W' and 'S' keys for the left paddle, arrow keys for the right paddle.
          The game will pause when you click away and resume when you click back on it.
        </p>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          border: '2px solid #333',
          borderRadius: '8px',
          overflow: 'hidden'
        }}>
          <Pong />
        </div>
      </section>

      <section style={{
        marginBottom: '40px',
        textAlign: 'center'
      }}>
        <h2 style={{ fontSize: '1.8em', marginBottom: '20px' }}>
          More Projects
        </h2>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <a 
            href="https://github.com/YourGithubUsername" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              padding: '10px 20px',
              backgroundColor: '#333',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '5px',
              transition: 'background-color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#444'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#333'}
          >
            GitHub Projects
          </a>
          {/* Add more project links as needed */}
        </div>
      </section>
    </div>
  );
};

export default ProfilePage; 